module.exports = __webpack_public_path__ + "static/media/Partner-LogosSoSoGood.92131fbe.png";